import {
  Button,
  TableCell,
  TableRow,
  Typography
} from '@mui/material';
import numeral from 'numeral';
import { useNavigate } from 'react-router-dom';

const TableRowItem = (props: any) => {
  const userID = props.user.id;

  const navigate = useNavigate();

  const onViewUserDetails = () => {
    navigate(`/dashboard/users?u=${userID}`);
  }

  return (
    <TableRow hover tabIndex={-1} role="checkbox">
      
      <TableCell onClick={onViewUserDetails} sx={{ fontWeight: 700, color: "#2D60FF" }} align="left">
        <Button>
          <Typography variant="subtitle2" noWrap sx={{ textDecoration: 'underline' }}>
            {userID}
          </Typography>
        </Button>
      </TableCell>
      <TableCell align="center" >{props.user?.displayName}</TableCell>
      <TableCell align="center">{numeral(props.totalRedeemedTickets).format("0,000")}</TableCell>
      <TableCell align="center" >{props.user?.emailAddress}</TableCell>
    </TableRow>
  );
}

export default TableRowItem;
